let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6t2MT")).then(() => parcelRequire('7sYlT'));